import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createSiteAndLink } from '@api/manageCrowdCells';

import { ESnackbarTypes } from '@enums/common';

import { ADD_SITE_AND_LINK, CROWDCELLS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreateSiteAndLink = (onSettledCallbacks?: Array<() => void>) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleAddSiteAndLink,
		isLoading: isLoadingAddSiteAndLink,
	} = useMutation({
		mutationKey: [ADD_SITE_AND_LINK],
		mutationFn: createSiteAndLink,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.createSiteAndLinkCrowdCell,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CROWDCELLS])];
		},
	});

	return {
		handleAddSiteAndLink,
		isLoadingAddSiteAndLink,
	};
};
